import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';

import { BrandDetail } from './branddetail';
import { CatalogInnerSections } from 'vpl.tas.listing';
import { CatalogItems } from 'vpl.tas.listing';
import { SmartFilter } from 'vpl.tas.listing';
import { BrandProjects } from '../news.list/brandprojects';

export const BrandsDetailPage = {
    components: {
        ItemEditBtns,
        BrandDetail,
        CatalogInnerSections,
        SmartFilter,
        CatalogItems,
        BrandProjects
    },
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    methods: {

    },
    mounted(){

    },
    template: `
<div style="display: contents;">
    <BrandDetail :structKey="this.structKey" />
    <section class="section">
        <div class="container">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Ассортимент бренда
                    </h2>
                </div>
            </div>
            <div class="catalog-wp">
                <CatalogInnerSections :structKey="this.structKey" />
                <div class="catalog__bottom js-catalog-wp">
                    <SmartFilter :structKey="this.structKey" />
                    <CatalogItems :structKey="this.structKey" />
                </div>
            </div>
        </div>
    </section>
    <BrandProjects :structKey="this.structKey" :brandName="this.struct[this.structKey].componentData.NAME" />
    <section v-if="this.struct[this.structKey].componentData.BOTTOM_TEXT" class="section seo-text-section brand__seo-section">
        <div class="container">
            <div class="brand__seo-text content" v-html="this.struct[this.structKey].componentData.BOTTOM_TEXT">
            </div>
        </div>
    </section>
</div>
    `
}